import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { CommonService } from '../Model/Common/common.service';
import { RouterModule } from '@angular/router';
import { ComboService } from '../Model/Combo/combo.service';
import moment from 'moment';
import { UtilityService } from '../Model/utility/utility.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { SessionService } from '../Util/Session/session.service';
import { ApprovalMatrixFormFilterComponent } from '../Setting/ApprovalMatrixFormFilter/approval-matrix-form-filter/approval-matrix-form-filter.component';
import { ApprovalMatrixService } from '../Model/ApprovalMatrix/approval-matrix.service';
import { AttendanceService } from '../Model/Attendance/attendance.service';

@Component({
  selector: 'app-exceptional-days-form',
  standalone: true,
  imports: [LoaderComponent, NgSelectModule, CommonModule, FormsModule, NgbDatepickerModule, DataTablesModule, RouterModule],
  templateUrl: './exceptional-days-form.component.html',
  styleUrl: './exceptional-days-form.component.scss'
})
export class ExceptionalDaysFormComponent {

  isDisabled: boolean = false;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Years = [] as any;
  Branchs = [] as any;
  Sites = [] as any;
  SitesFilter = [] as any;
  ApplicabilityDatas = [] as any;
  ApplicabilityDatasFilter = [] as any;
  Applicabilitys = [] as any;

  user = [] as any;
  ApprovalSubCategory = [] as any;
  ApprovalSubCategoryFilter = [] as any;
  Companys = [] as any;
  CompanysFilter = [] as any;
  Departments = [] as any;
  DepartmentsFilter = [] as any;
  Users = [] as any;
  UsersFilter = [] as any;

  BranchsFilter = [] as any;
  Clients = [] as any;
  ClientsFilter = [] as any;


  Designations = [] as any;
  DesignationsFilter = [] as any;
  Grades = [] as any;
  GradesFilter = [] as any;

  LastWebESSApplicabilityId = null;

  AttendanceRuleDetail = {
    SelectType: 'insert',
    ESS_AttendanceRuleID: 0,
    AttendanceRuleName: null,
    WebCheckInOut: false,
    RestrictIP: false,
    IP: null,
    MobileCheckInOut: false,
    GeoTagging: false,
    SiteQRCodeScanning: false,
    SiteQRMandatory: false,
    EmployeeQRCodeScanning: false,
    EmployeeQRMandatory: false,
    Selfie: false,
    SelfieType: false,
    Restrict_IMEI: false,
    EmployeeNotCheckIn: false,
    PaySlip: false,
    Leave: false,
    Regularization: false,
    AttendanceSummary: false,
    Menu: false,
    OtherDuty: false,
    ReportingPerson: false,
    BranchContact: false,
    CompanyContact: false,
    IsLetterApproval: false,
    IsTaxDeclaration: false,
    IsTaxDetails: false,
    IsExpense: false,
    DefaultAttendance: false,
    WebESSApplicabilityId: null as any,
    MappedId: null as any,
    IsOtherDuty: false,
    IsAttendanceAll: false,
    GeoTaggingNotMapped: false,
    IsOnlineAttendance: false,
    IsOtherDutySelf: false,
    IsSiteManpowerLimit: false,
    AllowAttendanceOnAnySite: false,
    EmpType: 'FRONT',
    IsHelpDesk: false,
    IsEmpProfile: false,
    IsOutDoor: false,
    IsMyTeam: false,
    IsCompOff: false,
    IsCompOffConsume: false,
    IsOptionalHoliday: false
  }

  constructor(
    public common: CommonService,
    private combo: ComboService,
    private utility: UtilityService,
    private toast: ToastService,
    protected tooltip: TooltipService,
    private modalService: NgbModal,
    private session: SessionService,
    private approvalMatrix: ApprovalMatrixService,
    private attendance: AttendanceService,
  ) { }

  Filter = {
    Year: null as any,
    BranchID: null,
    ClientID: null,
    SiteID: null,
    Date: null as any,
    EmpType: 'FRONT',
    BranchId: null,
    SiteIdObj: null as any,
    Site: null
    // Site: null
  }

  ngOnInit(): void {
    if (this.AttendanceRuleDetail.ESS_AttendanceRuleID > 0) {
      this.AttendanceRuleLoadGet();
    } else {
      this.GetApplicability()
    }
    this.ComboLoad('Branch');
    this.SelectDate('RegistrationDate', null, null);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    // if (Combotype === 'Branch') {
    //   this.Clients = [];
    //   this.Filter.BranchId = null;
    //   this.Sites = [];
    //   this.Filter.ClientID = null;
    //   this.Filter.SiteID = null;
    // } else if (Combotype === 'Client') {
    //   console.log(this.Filter.BranchId);
    //   this.Filter.ClientID = null;
    //   this.Sites = [];
    //   this.Filter.SiteID = null;
    // } else if (Combotype === 'Site') {
    //   this.Filter.SiteID = null;
    // }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      // 'BranchId': (Combotype == 'Client') ? this.Filter.BranchId : 0,
      // 'ClientId': (Combotype == 'Site') ? this.Filter.ClientID : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.Branchs = response.ComboLoad;
        } else if (Combotype == 'Site') {
          this.Sites = response.ComboLoad;
        }
        // this.TablesDatas = [];
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetEmpType() {
    console.log(this.Filter.EmpType);
  }

  CheckDiselect() {
    if (this.Filter.SiteIdObj != null) {
      const SiteIdObjfilter = [] as any;
      this.Filter.SiteIdObj.forEach((element: any) => {
        if (this.SitesFilter.filter((e: any) => this.common.ToLowerCase(e.IsClientMapped) == 'mapped' && e.SiteMasterID != this.Filter.Site).map((e: any) => e.SiteMasterID).filter((e: any) => e == element).length == 0) {
          SiteIdObjfilter.push(element);
        }
      });
      this.Filter.SiteIdObj = SiteIdObjfilter;
    }
  }

  CheckAll(event: any, Type: String) {
    if (Type == 'Site') {
      if (event.target.checked) {
        this.Filter.SiteIdObj = this.Sites.map((e: any) => e.SiteMasterID);
      } else {
        this.Filter.SiteIdObj = [];
      }
    }
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        console.log(response);
        if (SelectType == 'RegistrationDate') {
          this.Years = [moment(response.Table[0].RegistrationDate.RegistrationDate).year() - 1, moment(response.Table[0].RegistrationDate).year(), moment(response.Table[0].RegistrationDate).year() + 1];
          console.log("year", this.Years);

        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }

  logFilter() {
    console.log(this.Filter);
  }

  SearchDropdown(SearchValue: string, Label: string) {
    if (Label == 'Applicability') {
      this.ApplicabilityDatasFilter = this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityData.toLowerCase().includes(SearchValue.toLowerCase()));
    }
  }

  ButtonApplicabilityDataFilter(id = 0) {
    if (
      (id == 3 || id == 4 || id == 8) ||
      (id == 0 && (this.AttendanceRuleDetail.WebESSApplicabilityId == 3 || this.AttendanceRuleDetail.WebESSApplicabilityId == 4 || this.AttendanceRuleDetail.WebESSApplicabilityId == 8))) {
      this.ApplicabilityDataFilter(true);
    } else {
      this.toast.show({ message: "Filter only allow for client & site", type: toastTypeEnum.warning });
    }
  }

  async ApplicabilityDataFilter(IsFilter = false) {
    // if (this.AttendanceRuleDetail.WebESSApplicabilityId != 8 || !IsFilter) {
    //   this.ApplicabilityDatas = [];
    //   this.ApplicabilityDatasFilter = [];
    // }
    if (IsFilter || await this.Confirmation(IsFilter)) {
      if (!IsFilter) {
        this.ApplicabilityDatas = [];
        this.ApplicabilityDatasFilter = [];
        this.AttendanceRuleDetail.MappedId = null;
        this.LastWebESSApplicabilityId = this.AttendanceRuleDetail.WebESSApplicabilityId;
      } else {
        this.ApplicabilityDatas = this.ApplicabilityDatasFilter.filter((e: any) => e.IsCheck);
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
      }

      this.Filter.BranchID = null;
      this.Filter.ClientID = null;
      this.Filter.SiteID = null;
      if (this.AttendanceRuleDetail.WebESSApplicabilityId == 1) {
        this.ApprovalComboLoad('Company');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 5) {
        this.ApprovalComboLoad('Department');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 6) {
        this.ApprovalComboLoad('Designation');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 7) {
        this.ApprovalComboLoad('User');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 9) {
        this.ApprovalComboLoad('Grade');
      } else {
        if (this.AttendanceRuleDetail.WebESSApplicabilityId != 0) {
          this.FilterForm();
        }
      }
    }
  }

  async Confirmation(IsFilter = false): Promise<boolean> {
    if (!IsFilter && this.LastWebESSApplicabilityId != null) {
      const modalRef = this.modalService.open(ConfirmationComponent);
      modalRef.componentInstance.Message = this.tooltip.Message.ApplicabiliyChangeMessgae;
      modalRef.componentInstance.Message2 = this.tooltip.Message.ApplicabiliyChangeMessgae2;
      return modalRef.result.then((result) => {
        if (!result) {
          this.AttendanceRuleDetail.WebESSApplicabilityId = this.LastWebESSApplicabilityId;
        }
        return result;
      });
    } else {
      return true;
    }
  }

  ApprovalComboLoad(Combotype: String, Combotype2 = null as any, index = 0) {
    this.isDisabled = true;
    this.combo.ApprovalComboLoad({
      'SelectType': Combotype,
      'BranchId': this.Filter.BranchID,
      'ClientId': this.Filter.ClientID,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Company') {
          this.Companys = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));
          this.CompanysFilter = response.Table.filter((e: any) => e.CompanyMasterId == parseInt(this.session.GetUserDetails().CompanyMasterId));

          this.Companys.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.CompanyMasterId,
                ApplicabilityData: element.CompanyName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.CompanyMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Branch') {
          this.Branchs = response.Table;
          this.BranchsFilter = response.Table;

          this.Branchs.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Department') {
          this.Departments = response.Table;
          this.DepartmentsFilter = response.Table;

          this.Departments.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DepartmentMasterID,
                ApplicabilityData: element.DepartmentName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DepartmentMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.Table;
          this.DesignationsFilter = response.Table;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.DesignationMasterID,
                ApplicabilityData: element.DesignationName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.DesignationMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'Client') {
          this.Clients = response.Table;
          this.ClientsFilter = response.Table;

          this.Clients.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.ClientGroupMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.ClientGroupMasterID,
                  ApplicabilityData: element.ClientGroupName,
                  WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.ClientGroupMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Site') {
          this.Sites = response.Table;
          this.SitesFilter = response.Table;

          this.Sites.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteName,
                  WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                  IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.SiteMasterID) >= 0 ? true : false : false,
                }
              );
            }
          });
        } else if (Combotype == 'Designation') {
          this.Designations = response.ComboLoad;
          this.DesignationsFilter = response.ComboLoad;

          this.Designations.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.BranchMasterID,
                ApplicabilityData: element.BranchName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.BranchMasterID) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == null) {
          this.Users = response.Table;
          this.UsersFilter = response.Table;

          this.Users.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.UserMasterId,
                ApplicabilityData: element.UserName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.UserMasterId) >= 0 ? true : false : false,
              }
            );
          });
        } else if (Combotype == 'User' && Combotype2 == 'Employee') {
          response.Table.forEach((element: any) => {
            this.ApprovalSubCategory.push(
              {
                ApprovalSubCategoryID: element.UserMasterId,
                ApprovalSubCategory: element.UserName,
              }
            );
          });
          this.ApprovalSubCategoryFilter[index] = this.ApprovalSubCategory;
        } else if (Combotype == 'Grade') {
          this.Grades = response.Table;
          this.GradesFilter = response.Table;

          this.Grades.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.GradeMasterId,
                ApplicabilityData: element.GradeName,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: this.AttendanceRuleDetail.MappedId != null ? this.AttendanceRuleDetail.MappedId.split(',').findIndex((e: any) => e == element.GradeMasterId) >= 0 ? true : false : false,
              }
            );
          });
        }
        this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        this.AttendanceRuleDetail.MappedId = null;
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterForm() {
    const modalRef = this.modalService.open(ApprovalMatrixFormFilterComponent, { size: 'lg' });
    modalRef.componentInstance.Title = this.AttendanceRuleDetail.WebESSApplicabilityId == 3 ? 'Client' : this.AttendanceRuleDetail.WebESSApplicabilityId == 4 ? 'Site' : this.AttendanceRuleDetail.WebESSApplicabilityId == 8 ? 'Employee' : '';
    modalRef.componentInstance.WebESSApplicabilityId = this.AttendanceRuleDetail.WebESSApplicabilityId;
    modalRef.componentInstance.EmpType = this.AttendanceRuleDetail.EmpType;
    modalRef.componentInstance.ShowFilter = {
      ShowBranch: (this.AttendanceRuleDetail.WebESSApplicabilityId == 3 || this.AttendanceRuleDetail.WebESSApplicabilityId == 4 || this.AttendanceRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowClient: (this.AttendanceRuleDetail.WebESSApplicabilityId == 4 || this.AttendanceRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSite: (this.AttendanceRuleDetail.WebESSApplicabilityId == 6) ? true : false,
      ShowSearchEmployee: (this.AttendanceRuleDetail.WebESSApplicabilityId == 8 || this.AttendanceRuleDetail.WebESSApplicabilityId == 4) ? true : false
    }
    modalRef.result.then(result => {
      this.Filter.BranchID = result.BranchID;
      this.Filter.ClientID = result.ClientID;
      this.Filter.SiteID = result.SiteID;
      if (this.AttendanceRuleDetail.WebESSApplicabilityId == 1) {
        //this.ApprovalComboLoad('Company');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 2) {
        this.ApprovalComboLoad('Branch');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 3) {
        this.ApprovalComboLoad('Client');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 4) {
        if (result.length >= 0) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.SiteMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.SiteMasterID,
                  ApplicabilityData: element.SiteCode + '-' + element.SiteName,
                  WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                  IsCheck: true,
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else {
          this.ApprovalComboLoad('Site');
        }
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 5) {
        //this.ComboLoad('Department');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 6) {
        //this.ComboLoad('Designation');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 7) {
        //this.ComboLoad('User');
      } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 8) {
        if (result != undefined) {
          result.forEach((element: any) => {
            if (this.ApplicabilityDatas.filter((e: any) => e.ApplicabilityDataID == element.EmpMasterID).length == 0) {
              this.ApplicabilityDatas.push(
                {
                  ApplicabilityDataID: element.EmpMasterID,
                  ApplicabilityData: element.FullName,
                  WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                  IsCheck: true
                }
              );
            }
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        }
      }
    });
  }

  OrderByApplicability() {
    return this.ApplicabilityDatasFilter.sort((a: any, b: any) => a.ApplicabilityData.localeCompare(b.ApplicabilityData));
  }

  ApplicabilityCheckAll(event: any) {
    this.ApplicabilityDatasFilter.map((e: any) => e.IsCheck = event.target.checked);
  }

  AttendanceRuleLoadGet() {
    this.isDisabled = true;
    this.attendance.AttendanceRuleLoadGet({ SelectType: 1, ESS_AttendanceRuleID: this.AttendanceRuleDetail.ESS_AttendanceRuleID }).subscribe({
      next: (response) => {
        if (response.Table[0].EmpType == null || response.Table[0].EmpType == '') {
          response.Table[0].EmpType = 'FRONT';
        } else {
          response.Table[0].EmpType = response.Table[0].EmpType.toUpperCase();
        }
        this.AttendanceRuleDetail = response.Table[0];
        this.AttendanceRuleDetail.MappedId = response.Table2.map((e: any) => e.MappedId).toString();
        this.AttendanceRuleDetail.SelectType = 'update';
        this.LastWebESSApplicabilityId = this.AttendanceRuleDetail.WebESSApplicabilityId;
        if (this.AttendanceRuleDetail.WebESSApplicabilityId == 1) {
          this.ApprovalComboLoad('Company');
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 2) {
          this.ApprovalComboLoad('Branch');
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 3) {
          //this.ApprovalComboLoad('Client');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 4) {
          //this.ApprovalComboLoad('Site');
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 5) {
          this.ApprovalComboLoad('Department');
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 6) {
          this.ApprovalComboLoad('Designation');
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 7) {
          this.ApprovalComboLoad('User');
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 8) {
          // response.Table2.map((e: any) => e.MappedId).forEach((element: any) => {
          //   this.ComboLoad('EmpLoadOnId', element);
          // });
          response.Table2.forEach((element: any) => {
            this.ApplicabilityDatas.push(
              {
                ApplicabilityDataID: element.MappedId,
                ApplicabilityData: element.MappedValue,
                WebESSApplicabilityId: this.AttendanceRuleDetail.WebESSApplicabilityId,
                IsCheck: true
              }
            );
          });
          this.ApplicabilityDatasFilter = this.ApplicabilityDatas;
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 9) {
          this.ApprovalComboLoad('Grade');
        }

        if (this.AttendanceRuleDetail.WebESSApplicabilityId == 8) {
          this.GetApplicability(false);
        } else {
          this.GetApplicability();
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetApplicability(IsClear = true) {
    this.isDisabled = true;
    this.approvalMatrix.GetApplicability({ SelectType: 'SR', WebESSApplicabilityMasterID: 0, EmpType: this.AttendanceRuleDetail.EmpType }).subscribe({
      next: (response) => {
        this.Applicabilitys = response.Table;
        if (response.Table.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0) >= 0) {
          this.Applicabilitys.push(response.Table.filter((e: any) => e.WebESSApplicabilityMasterID == 0)[0]);
          this.Applicabilitys.splice(this.Applicabilitys.findIndex((e: any) => e.WebESSApplicabilityMasterID == 0), 1);
        }
        if (this.Applicabilitys.filter((e: any) => e.WebESSApplicabilityMasterID == this.AttendanceRuleDetail.WebESSApplicabilityId).length == 0) {
          this.AttendanceRuleDetail.WebESSApplicabilityId = null;
          this.ApplicabilityDatasFilter = [];
        } else if (this.AttendanceRuleDetail.WebESSApplicabilityId == 8 && IsClear) {
          this.ApplicabilityDatasFilter = [];
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
